export default {
  methods: {
    toDelayColor: function(delay) {
      return this.delayToColor(delay);
    },

    delayDelta: function(previousStop, stop) {
      if (previousStop && stop) {
        if (previousStop.departure) {
          var newDelayMinutes;
          if (stop.departure) {
            newDelayMinutes = stop.departure.delayMinutes;
          } else if (stop.arrival) {
            newDelayMinutes = stop.arrival.delayMinutes;
          }
          var result = newDelayMinutes - previousStop.departure.delayMinutes;
          return result;
        }
      }
    },

    delayToColor: function(delay) {
      if (delay <= 5) {
        return "green";
      }
      return "red";
    },

    delayToTriStateColor: function(delay) {
      if (delay <= 5) {
        return "green";
      } else if (delay <= 20) {
        return "yellow";
      }
      return "red";
    },

    formatDelay: function(delay, brackets) {
      if (brackets) {
        return '(' + this.formatDelay(delay, false) + ')';
      } else {
        if (delay < 0) {
          return Math.round(delay * 10 + Number.EPSILON) / 10;
        } else {
          return "+" + Math.round(delay * 10 + Number.EPSILON) / 10;
        }
      }
    },

    toDelay: function(arrivalOrDeparture) {
      if (arrivalOrDeparture && arrivalOrDeparture.delayMinutes) {
        return this.formatDelay(arrivalOrDeparture.delayMinutes, true);
      }
    },
  },
};
